(function () {
  const root = document.getElementById("productFitment");
  if (!root) return;

  const handle = root.dataset.productHandle;
  const catalogUrl = root.dataset.catalogUrl;
  const customerId = root.dataset.customerId;
  const titleEl = document.getElementById("productFitmentTitle");
  const subEl = document.getElementById("productFitmentSub");
  const linkEl = document.getElementById("productFitmentLink");
  const alsoRoot = document.getElementById("productFitAlso");
  const alsoTitle = document.getElementById("productFitAlsoTitle");
  const alsoSub = document.getElementById("productFitAlsoSub");
  const alsoGrid = document.getElementById("productFitAlsoGrid");

  const SLOT_ORDER = ["strut", "coilover", "mirrors", "shifter", "paddles"];

  function profileKey() {
    return customerId ? `brace1-garage-profile-v1-${customerId}` : "brace1-garage-profile-v1";
  }

  function readProfile() {
    try {
      const raw = localStorage.getItem(profileKey());
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  function money(n) {
    const value = Number(n);
    if (!Number.isFinite(value)) return "";
    return `$${value.toFixed(2)}`;
  }

  function vehicleLabel(v) {
    if (!v) return "";
    const year = v.year ? `${v.year} ` : "";
    return `${year}${v.make || ""} ${v.model || ""}`.trim();
  }

  function partFitsVehicle(part, vehicle) {
    if (!part?.vehicles?.length || !vehicle?.make || !vehicle?.model) return false;
    const year = Number(vehicle.year);
    return part.vehicles.some((row) => {
      if (row.make !== vehicle.make || row.model !== vehicle.model) return false;
      if (!year) return true;
      return year >= row.yearStart && year <= row.yearEnd;
    });
  }

  function savedVehicle(profile) {
    if (profile.lastVehicle?.make && profile.lastVehicle?.model) {
      return profile.lastVehicle;
    }
    const builds = Object.values(profile.vehicleBuilds || {});
    if (builds.length) {
      const latest = builds[builds.length - 1];
      if (latest.make && latest.model) return latest;
    }
    return null;
  }

  function showBanner(title, sub, linkText, linkHref) {
    if (titleEl) titleEl.textContent = title;
    if (subEl) subEl.textContent = sub || "";
    if (linkEl) {
      linkEl.textContent = linkText || "Open garage";
      linkEl.href = linkHref || "/pages/garage";
    }
    root.hidden = false;
  }

  function relatedParts(parts, current, vehicle) {
    const pool = parts.filter((part) => {
      if (!part || part.handle === current.handle) return false;
      if (!part.available) return false;
      if (vehicle) return partFitsVehicle(part, vehicle);
      return (part.vehicles || []).some((row) =>
        (current.vehicles || []).some(
          (mine) => mine.make === row.make && mine.model === row.model
        )
      );
    });

    pool.sort((a, b) => {
      const slotDiff =
        SLOT_ORDER.indexOf(a.slot) - SLOT_ORDER.indexOf(b.slot) ||
        String(a.slot || "").localeCompare(String(b.slot || ""));
      if (slotDiff) return slotDiff;
      if (a.slot === current.slot && b.slot !== current.slot) return 1;
      if (b.slot === current.slot && a.slot !== current.slot) return -1;
      return Number(b.price || 0) - Number(a.price || 0);
    });

    const seenSlots = new Set();
    const prioritized = [];
    pool.forEach((part) => {
      if (part.slot === current.slot) return;
      if (seenSlots.has(part.slot)) return;
      seenSlots.add(part.slot);
      prioritized.push(part);
    });

    const fill = pool.filter((part) => !prioritized.includes(part));
    return [...prioritized, ...fill].slice(0, 3);
  }

  function renderAlso(current, related, vehicle) {
    if (!alsoRoot || !alsoGrid || !related.length) return;

    const label = vehicle ? vehicleLabel(vehicle) : "this vehicle";
    if (alsoTitle) {
      alsoTitle.textContent = vehicle
        ? `Also bought for your ${label}`
        : "Drivers also add these";
    }
    if (alsoSub) {
      alsoSub.textContent = vehicle
        ? `Brace1 parts that also fit your ${label} — add them to finish your build.`
        : "Brace1 parts that share this fitment — add them to finish your build.";
    }

    alsoGrid.innerHTML = related
      .map((part) => {
        const img = part.image
          ? `<img class="product-fit-also__img" src="${part.image}" alt="" loading="lazy" />`
          : `<span class="product-fit-also__img product-fit-also__img--empty">Part</span>`;
        return `
          <a class="product-fit-also__card" href="${part.url || "#"}">
            ${img}
            <span class="product-fit-also__name">${part.name}</span>
            <span class="product-fit-also__meta">${part.meta || part.slot || ""} · +${Math.round(Number(part.price || 0))} PTS</span>
            <span class="product-fit-also__price">${money(part.price)}</span>
            <span class="product-fit-also__cta">View part</span>
          </a>
        `;
      })
      .join("");

    alsoRoot.hidden = false;
  }

  fetch(catalogUrl)
    .then((res) => res.json())
    .then((data) => {
      const parts = data.parts || [];
      const part = parts.find((row) => row.handle === handle);
      if (!part) return;

      const profile = readProfile();
      const saved = savedVehicle(profile);
      const fitsSaved = saved && partFitsVehicle(part, saved);
      const fitLabels = (part.vehicles || [])
        .map((v) => `${v.make} ${v.model} (${v.yearStart}–${v.yearEnd})`)
        .slice(0, 3);

      if (fitsSaved) {
        showBanner(
          `Fits your ${vehicleLabel(saved)}`,
          `${part.meta || "Confirmed fitment"} · +${Math.round(Number(part.price || 0))} PTS toward your garage build.`,
          "Complete your build in the garage",
          "/pages/garage"
        );
      } else if (fitLabels.length) {
        showBanner(
          "Confirmed Brace1 fitment",
          `Fits: ${fitLabels.join(" · ")}${part.vehicles.length > 3 ? " · more" : ""}`,
          saved ? "Check fit for your car in the garage" : "Select your car to confirm fit",
          "/pages/garage"
        );
      }

      const related = relatedParts(parts, part, fitsSaved ? saved : null);
      renderAlso(part, related, fitsSaved ? saved : null);
    })
    .catch(() => {});
})();
